import { Col, Row, theme, Typography } from 'antd';
import { MissingField } from 'pos-client/components/generic/missing-field/MissingField.tsx';
import { PosLabel } from 'pos-client/components/shared/Form/PosLabel.tsx';

export const LabelledDetail = ({
  label,
  detail,
  tooltip,
  direction = 'vertical',
}: {
  label: string;
  detail: string | React.ReactNode | undefined | null;
  tooltip?: string | React.ReactNode | undefined;
  direction?: 'horizontal' | 'vertical';
}) => {
  const { token } = theme.useToken();

  return direction === 'vertical' ? (
    <Col>
      <PosLabel label={label} tooltip={tooltip} boldLabel />
      <Typography.Text style={{ color: token.colorTextSecondary }}>
        {detail ?? <MissingField />}
      </Typography.Text>
    </Col>
  ) : (
    <Row>
      <PosLabel
        label={label}
        tooltip={tooltip}
        boldLabel
        style={{ marginRight: token.marginSM }}
      />
      <Typography.Text style={{ color: token.colorTextSecondary }}>
        {detail ?? <MissingField />}
      </Typography.Text>
    </Row>
  );
};
